import { FilterOption } from '@/components/v1/molecules/data-table/data-table-toolbar';

type WorkflowFilterSource = {
  metadata: { id: string };
  name: string;
};

export function buildWorkflowFilterOptions(
  workflows: WorkflowFilterSource[],
  counts: ReadonlyMap<string, number>,
  cappedWorkflowIds: ReadonlySet<string>,
): FilterOption[] {
  return workflows
    .map((workflow) => ({
      value: workflow.metadata.id,
      label: workflow.name,
      count: counts.get(workflow.metadata.id),
      ...(cappedWorkflowIds.has(workflow.metadata.id)
        ? { countLabel: '20k+' }
        : {}),
    }))
    .sort((left, right) => {
      if (left.count === right.count) {
        return left.label.localeCompare(right.label);
      }
      if (left.count === undefined) {
        return 1;
      }
      if (right.count === undefined) {
        return -1;
      }
      return right.count - left.count;
    });
}
